import { useState } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { NavItem } from 'components/navbar'
import { storeCategoryPath } from 'lib/urls'
import { Guides, SubNav } from './dropdown-content'
import css from '../navbar.scss'
import { NAV_HEIGHT, STORE_HEADER_HEIGHT } from '../constants'

// offset the backdrop top so the navbar isn't covered
// adjust to include the global nav when at the top of the page
const getModalBackdropOffest = () => {
  const scrollOffset = window.pageYOffset
  return scrollOffset > STORE_HEADER_HEIGHT
    ? `${NAV_HEIGHT}px`
    : `${STORE_HEADER_HEIGHT - scrollOffset}px`
}

const CategoryDropdown = ({ category, isActiveItem }) => {
  const [open, setOpen] = useState(false)
  let openTimer
  let closeTimer

  const closePopup = () => {
    clearTimeout(openTimer)
    closeTimer = setTimeout(() => setOpen(false), 100)
  }

  const openPopup = () => {
    clearTimeout(closeTimer)
    openTimer = setTimeout(() => setOpen(true), 250)
  }

  const { title, urlSlug, children, guides } = category
  const hasChildren = children && children.length > 0
  const hasGuides = guides && guides.length > 0

  return (
    <>
      <NavItem
        router
        key={title}
        onClick={closePopup}
        onMouseLeave={closePopup}
        onMouseEnter={openPopup}
        className={classNames(css.catalogNavItem, {
          [css.catalogNavItemActive]: isActiveItem,
        })}
        to={{
          state: { slugSet: [urlSlug] },
          pathname: storeCategoryPath(urlSlug),
        }}
      >
        {title}
      </NavItem>

      {open && (hasChildren || hasGuides) && (
        <>
          <div className={`${css.categoryDropdown}`}>
            <div className="container">
              <div
                className={`fadeIn ${css.categoryDropdownContent}`}
                onMouseEnter={openPopup}
                onMouseLeave={closePopup}
              >
                {hasChildren && (
                  <SubNav items={children} closeDropdown={closePopup} />
                )}
                {hasGuides && <Guides title={title} guides={guides} />}
              </div>
            </div>
          </div>
          <div
            className={`modal-backdrop ${css.dropdownBackdrop}`}
            style={{ top: getModalBackdropOffest() }}
          />
        </>
      )}
    </>
  )
}

CategoryDropdown.propTypes = {
  category: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      urlSlug: PropTypes.string.isRequired,
      children: PropTypes.array.isRequired,
      guides: PropTypes.array.isRequired,
    })
  ).isRequired,
  isActiveItem: PropTypes.bool.isRequired,
}

export default CategoryDropdown
